import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary to-secondary">
      <div className="container mx-auto px-4 py-16">
        <nav className="flex justify-between items-center mb-16">
          <div className="flex items-center space-x-2">
            <img src="/brain-icon.svg" alt="Notegenius Logo" className="w-8 h-8" />
            <h1 className="text-3xl font-bold text-white">Notegenius</h1>
          </div>
          <button
            onClick={() => navigate('/auth')}
            className="bg-white text-primary px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 transition-all"
          >
            Get Started
          </button>
        </nav>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Transform Your Lectures into Smart Notes
            </h2>
            <p className="text-xl text-white opacity-90 mb-8">
              Record your lectures, get instant transcriptions, and AI-powered summaries. 
              Never miss important information again.
            </p>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="bg-white p-2 rounded-full">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                  </svg>
                </div>
                <span className="text-white text-lg">Record lectures with ease</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="bg-white p-2 rounded-full">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <span className="text-white text-lg">Get instant transcriptions</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="bg-white p-2 rounded-full">
                  <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <span className="text-white text-lg">AI-powered summaries</span>
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            {/* Add illustration or screenshot here */}
            <div className="bg-white bg-opacity-10 p-8 rounded-2xl backdrop-blur-lg">
              <div className="aspect-w-16 aspect-h-9 bg-white bg-opacity-20 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 